<template>  
  <div class="main" id="echart" ref="echart" :style="{height:$store.state.itemH}"></div>
</template>

<script>
  import { deviceApi } from "../../../../../static/js/api.js"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  export default {
    name: 'GroupInfo',
    data() {
      return {
        nameList:[],
        spaceData:[],
      }
    },
    mounted() {
    },
    created: async function () {
      // this.getWattMetter()
    },
    methods: {
      async getWattMetter(){
        let that = this;
        this.spaceData=[];
        this.nameList=[]
        const res = await deviceApi.getWattMetter()
        if(res.meta.code == '200'){
          for(var i in res.data.spaceList){
            const obj = {
              name:i,
              value:res.data.spaceList[i]
            }
            that.spaceData.push(obj)
            that.nameList.push(i)
          }
          that.spaceEchar();
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //空间耗水量对比
	    spaceEchar:function(){
        var that = this;
	    	this.$nextTick(function(){
          let myChart = that.$echarts.init(document.getElementById('echart'));
          var option = {
            title : {
              text: '空间耗水量对比图',
              x:'center',
              y:'33%',
              textStyle:{
                color:'#999',
                fontSize:'12',
              }
            },
            color:['#fb8957','#a374ea','#5c75f3','#40e0bc','#e06240'],
            tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              left: 'center',
              top: '50%',
              data: that.nameList,
              formatter:function(name){
                var target = 0;
                var total = 0;
                for(var i = 0; i < that.spaceData; i++){
                  total += that.spaceData[i].value
                  target = that.spaceData[i].value
                }
                if(total == 0){
                  return name+' '+target+'KWH'+'(0%)'
                }else{
                  return name+' '+target+'KWH'+'('+((target/total)*100).toFixed(2)+'%)'
                }
              }
            },
            series : [
              {
                name: '耗水量',
                type: 'pie',
                radius : '50%',
                center: ['50%', '20%'],
                // data:[
                //   {value:335, name:'一楼'},
                //   {value:310, name:'总裁办公室'},
                //   {value:234, name:'市场部'},
                //   {value:135, name:'研发部'},
                //   {value:1548, name:'三楼'}
                // ],
                data: that.spaceData,
                label:{
                  show:false,
                  normal: {
                    show: false
                  }
                },
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                    
                  }
                }
              }
            ]
          }
          myChart.setOption(option,true);
        })
      }
    },
    watch: {
      '$store.state.itemH':function(newVal){
        this.$refs.echart.style.height = newVal+'px'
        this.getWattMetter()
      }
    },
    destroyed(){
      this.$store.state.itemH = 0
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Page/CWaterManage/BuildingInfo/GroupInfo.vue